import { create } from "zustand";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";

const NoOfBinsGvpReportStore = create((set) => ({
  noOfBinsGvpData: [],
  noOfBinsGvpInnerData: [],
  noOfBinsGvpInnerDataLoading: false,
  noOfBinsGvpInnerDataError: null,
  loading: false,
  error: null,
  currentFilters: null,

  // ================= OUTER REPORT =================
  fetchNoOfBinsGvpOuterReport: async (queryParams) => {
    set({ loading: true, error: null, currentFilters: queryParams });

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const response = await apiCall({
        url: `${API_BASE_URL1}GVPReports/Kpi2DailyOuterReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        noOfBinsGvpData: Array.isArray(response) ? response : [],
        loading: false,
        error: null,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;

      console.log(message || "Error fetching data");

      // 🔐 401 Unauthorized
      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";   // redirect to login

        set({
          noOfBinsGvpData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      // ⚠️ 400 Bad Request
      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          noOfBinsGvpData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      // 📭 404 No Data
      else if (status === 404) {
        toast.error(error.message);
        set({
          noOfBinsGvpData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      // 🔴 500 Internal Server Error
      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          noOfBinsGvpData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }

      // ❓ Other Errors
      else {
        toast.error(message || "Something went wrong");
        set({
          noOfBinsGvpData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }

    } finally {
      set({ loading: false });
    }
  },

  // ================= INNER REPORT =================
  fetchNoOfBinsGvpInnerReport: async (queryParams) => {

    const queryString = new URLSearchParams(queryParams).toString();

    set({
      noOfBinsGvpInnerDataLoading: true,
      noOfBinsGvpInnerDataError: null,
    });

    try {
      const response = await apiCall({
        url: `${API_BASE_URL1}GVPReports/KPI2DailyInnerReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        noOfBinsGvpInnerData: Array.isArray(response) ? response : [],
        noOfBinsGvpInnerDataLoading: false,
        noOfBinsGvpInnerDataError: null,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;

      console.log(message || "Error fetching data");

      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          noOfBinsGvpInnerData: [],
          noOfBinsGvpInnerDataError: "Unauthorized",
          noOfBinsGvpInnerDataLoading: false,
        });
      }

      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          noOfBinsGvpInnerData: [],
          noOfBinsGvpInnerDataError: message || "Bad Request",
          noOfBinsGvpInnerDataLoading: false,
        });
      }

      else if (status === 404) {
        toast.error(error.message);
        set({
          noOfBinsGvpInnerData: [],
          noOfBinsGvpInnerDataError: "No Data found.",
          noOfBinsGvpInnerDataLoading: false,
        });
      }

      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          noOfBinsGvpInnerData: [],
          noOfBinsGvpInnerDataError: "Internal Server Error",
          noOfBinsGvpInnerDataLoading: false,
        });
      }

      else {
        toast.error(message || "Something went wrong");
        set({
          noOfBinsGvpInnerData: [],
          noOfBinsGvpInnerDataError: message || "Something went wrong",
          noOfBinsGvpInnerDataLoading: false,
        });
      }

    } finally {
      set({ noOfBinsGvpInnerDataLoading: false });
    }
  },

}));

export default NoOfBinsGvpReportStore;
